import { defineMessages } from 'react-intl';

export default defineMessages({
  readMore: {
    id: 'designSystemLanding.quoteStudent',
    defaultMessage: 'Lire avis',
  },
});
